import api from './api';
import { PatternRedactionElement } from '../types';

const URL = '/pattern-redaction-elements/';

class CriterionService {
  async forSkill(skillId: number): Promise<PatternRedactionElement[]> {
    return (await api.get(URL, { params: { owner_skill: skillId } })).data;
  }

  /** Critères qui s'appliquent à un exercice de ce pattern : SF des solutions, puis pattern. */
  async effectiveForPattern(patternId: number): Promise<PatternRedactionElement[]> {
    return (await api.get(`${URL}effective/`, { params: { pattern: patternId } })).data;
  }

  async create(data: Partial<PatternRedactionElement>): Promise<PatternRedactionElement> {
    return (await api.post(URL, data)).data;
  }

  async update(id: number, data: Partial<PatternRedactionElement>): Promise<PatternRedactionElement> {
    return (await api.patch(`${URL}${id}/`, data)).data;
  }

  async remove(id: number): Promise<void> {
    await api.delete(`${URL}${id}/`);
  }
}

const criterionService = new CriterionService();
export default criterionService;
